<template>
  <div class="tableWrapper">
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" stripe
:header-cell-style="{background:'#f5f7fa'}"  @selection-change="handleSelectionChange" @select-all = 'handleSelectionAll'>
        <!-- <el-table-column type="selection" :width="indexWidth"></el-table-column> -->
        <el-table-column v-if="tableIndex" label="序号" type="index" align="center" :width="indexWidth"> </el-table-column>
        <el-table-column v-for="(item,i) in infoList"  :key="i+item.name" :prop="item.code" :label="item.name" align="center" :width="item.width" ></el-table-column>
        <el-table-column v-for="(item,i) in filterInfoList"  :key="i+item.name" :prop="item.code" :label="item.name" align="center" :width="item.width">
            <template slot-scope="scope" >
                <span   v-if="item.filter[scope.row[item.filterCode]]=='normal'">{{ scope.row[item.code] }}</span>
                <span  style="color:#B5B5B6" v-if="item.filter[scope.row[item.filterCode]]=='grey'">{{ scope.row[item.code] }}</span>
                <span  style="color:#46D651" v-if="item.filter[scope.row[item.filterCode]]=='green'">{{ scope.row[item.code] }}</span>
                <span  style="color:#FF3D43" v-if="item.filter[scope.row[item.filterCode]]=='red'">{{ scope.row[item.code] }}</span>
                <span  style="color:#3399FF" v-if="item.filter[scope.row[item.filterCode]]=='blue'">{{ scope.row[item.code] }}</span>
                <span  style="color:#e6a23c" v-if="item.filter[scope.row[item.filterCode]]=='yellow'">{{ scope.row[item.code] }}</span>
            </template>
        </el-table-column>
        <el-table-column v-for="(item,i) in activeList"  :key="i+item.name"  :label="item.name" align="center" :width="item.width" > 
            <template slot-scope="scope" v-if="!isPatentsList||scope.row.isPush=='否'">
                <el-button
                size="mini"
                :class="{'blue':e.color=='blue'}"
                @click="handleEdit(scope.row,e.active)"
                v-for="(e,index) in item.button" :key="e+index">{{e.callbackText}}</el-button>
            </template>
        </el-table-column>

    </el-table>
  </div>
</template>

<script>
export default {
    props:{
        titleList:{
            type:Array
        },
        tableData:{
            type:Array
        },
        tableIndex:{
            type:Boolean,
            default:true
        },
        isPatentsList:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            infoList:[],
            filterInfoList:[],
            activeList:[],
            multipleSelection: [],
            indexWidth:0,
        }
    },
    mounted(){
        
        // let width = document.getElementsByClassName('tableWrapper')[0].clientWidth
        // width<900?width=900:''
        // this.indexWidth = 0.03*width
        // console.log(width);
        // console.log(document.getElementsByClassName('tableWrapper')[0]);
        // this.titleList.forEach(e=>{
        //     let ex = e.size*width/100
        //     e.width = ex
        //     e.button?this.activeList.push(e):e.filter?this.filterInfoList.push(e):this.infoList.push(e)
        // })
        this.resizeTo()
        window.onresize = ()=>{
            setTimeout(()=>{
                !this.isPatentsList&&this.resizeTo()
            },0)
        }
    },
    methods:{
        resizeTo(){
            this.activeList =[]
            this.filterInfoList =[]
            this.infoList =[]
            let width = document.getElementsByClassName('tableWrapper')[0].clientWidth
            width<900?width=900:''
            this.indexWidth = 0.03*width
            this.titleList.forEach(e=>{
                let ex = e.size*width/100
                e.width = ex
                e.button?this.activeList.push(e):e.filter?this.filterInfoList.push(e):this.infoList.push(e)
            })
            this.$forceUpdate()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            if(this.multipleSelection.length>1){
                this.$refs['multipleTable'].toggleRowSelection(val[0], false)
            }
            this.$emit('select',this.multipleSelection)
        },
        handleSelectionAll(val){
            this.$refs['multipleTable'].clearSelection()
        },
        handleEdit(row,e){
            this.$emit('callback',row,e)
        }
    }

}
</script>

<style lang="scss">
.tableWrapper{
    width: 100%;
    height: 100%;
    .el-table{
        height: 100%;
        .el-table__header-wrapper{
            .el-table__header{
                .has-gutter{
                    .cell{
                        overflow: initial;
                        font-size: 0.6rem;
                        color: #3E3A39;
                        white-space: nowrap;
                    }
                }
                .el-checkbox {
                    display: none;
                }
            }
        }
        .el-table__body-wrapper{
            overflow-y: auto;
            overflow-x: hidden;
            height: 90%;
            .el-table__row{
                font-size: 0.6rem;
                font-family: Arial;
                font-weight: 400;
                color: #3E3A39;
                .el-table__cell{
                    padding: 2px 0;
                    .cell{
                        font-size: 0.6rem;
                        color: #3E3A39;
                        .el-button--mini, .el-button--small{
                            font-size: 0.6rem;
                            color: #3E3A39
                        }
                        .blue{
                            background-color: #3399FF;
                            color: #fff ;
                        }
                    }
                }
            }
        }
        .el-table__fixed-right{
            .el-table__fixed-header-wrapper{
                .el-table__header{
                    thead{
                        .cell{
                            overflow: initial;
                            font-size: 0.6rem;
                            color: #3E3A39;
                            white-space: nowrap;
                        }
                    }
                    .el-checkbox {
                        display: none;
                    }
                }
            }
            .el-table__fixed-body-wrapper{
                .el-table__body{
                    .el-table__row{
                        font-size: 0.6rem;
                        font-family: Arial;
                        font-weight: 400;
                        color: #3E3A39;
                        .el-table__cell{
                            padding: 2px 0;
                            .cell{
                                font-size: 0.6rem;
                                color: #3E3A39;
                                .el-button--mini, .el-button--small{
                                    font-size: 0.6rem;
                                    color: #3E3A39
                                }
                                .blue{
                                    background-color: #3399FF;
                                    color: #fff ;
                                }
                            }
                        }
                    }

                }
            }
        }
        .el-table__fixed-right::before{
            content: none;
        }
    }
    .el-table::before{
        height: 0;
    }
    
}
</style>


// WEBPACK FOOTER //
// src/components/common/table.vue